import dayjs from "dayjs";
import dayjsTZ from "dayjs/plugin/timezone";

import { KazooError } from "@kazoohr/types";

import {
  getDateIfSupported,
  isValidIso8601DateWithTimezone,
  SupportedDateFormat,
} from "./dates/dateParsers";

dayjs.extend(dayjsTZ);
export class DateTimeWrapper {
  private _timezoneProvided: boolean = false;
  private _date: Date;

  constructor(
    input: string,
    supportedDateFormats: SupportedDateFormat[] = [
      "YYYYMMDD",
      "MMDDYYYY",
      "MMDDYY",
    ]
  ) {
    if (isValidIso8601DateWithTimezone(input)) {
      const parsed = dayjs(input);
      if (parsed.isValid()) {
        this._date = parsed.toDate();
        this._timezoneProvided = true;
        return;
      }
    }
    const asParsed = getDateIfSupported(input.trim(), {
      parseType: "FULL",
      supportedDateFormats,
    });
    if (!asParsed?.date) {
      throw new KazooError("packages.helpers.errors.invalidDate", {
        translationKey: "packages.helpers.errors.invalidDate",
        translationvalues: {
          value: input,
        },
      });
    }
    this._date = asParsed.date;
    this._timezoneProvided = asParsed.tzSpecified;
  }

  get date() {
    return this._date;
  }

  // this is basically only used for asking about birthdays
  localDate(timezone: string) {
    return dayjs(this._date).tz(timezone.replace(" ", "_"), false).date();
  }

  // this is basically only used for asking about birthdays
  localMonth(timezone: string) {
    return dayjs(this._date).tz(timezone.replace(" ", "_"), false).month();
  }

  toString() {
    return this.toISOString();
  }

  toISOString() {
    // this lets you treat DateWrapper like a date in your serializers
    return this._date.toISOString();
  }

  applyTimeZone(timezone: string) {
    this._date = dayjs(this._date)
      .tz(timezone.replace(" ", "_"), !this._timezoneProvided)
      .toDate();
    this._timezoneProvided = true;
  }
}
